import styled from 'foundations-theming/utils';
import CheckmarkIcon from '../../../Icons/CheckmarkIcon';
const CompletedIcon = styled(CheckmarkIcon).withConfig({
  displayName: "CompletedIcon",
  componentId: "h0ytcs-0"
})(["margin-right:5px;position:relative;bottom:-3px;color:", ";"], ({
  theme
}) => theme.color['fill-accent-teal-default']);
export default CompletedIcon;